// src/api/meta.ts
import api from "./client";

/**
 * ✅ Fetch Facebook & Instagram connection status
 */
export const getSocialMediaStatus = async () => {
  try {
    const res = await api.get("/getSocialMediaStatus");
    return res.data;
  } catch (error) {
    console.error("❌ Error fetching social media status:", error);
    return null;
  }
};

/**
 * ✅ Initiates OAuth flow for Facebook OR Instagram
 */
export const connectMeta = async (provider: "facebook" | "instagram") => {
  try {
    const stateData = JSON.stringify({ provider });

    const res = await api.post("/meta/oauth", {
      provider,
      state: stateData,
    });

    const data = res.data;

    console.log("📌 Redirecting to OAuth URL:", data.auth_url);
    window.location.href = data.auth_url;
  } catch (error: any) {
    console.error(`❌ Error connecting ${provider}:`, error);
    throw error;
  }
};

/**
 * ✅ Disconnect Facebook OR Instagram
 */
export const disconnectMeta = async (provider: "facebook" | "instagram") => {
  try {
    const res = await api.post("/meta/disconnect", { provider });
    return res.data;
  } catch (error) {
    console.error(`❌ Error disconnecting ${provider}:`, error);
    return null;
  }
};

/**
 * ✅ Disconnect ALL Meta providers
 */
export async function revokeMetaAccess(): Promise<void> {
  try {
    const res = await api.post("/meta/disconnect", {
      provider: "all",
    });

    return res.data;
  } catch (error) {
    console.error("❌ Error revoking Meta access:", error);
    throw new Error("Failed to revoke Meta access.");
  }
}
